// LinkedIn renders post text in a sans-serif font and has no native bold/italic, so we
// substitute Unicode "Mathematical Alphanumeric Symbols". The bold and bold-italic styles
// must use the SANS-SERIF blocks so they match regular text (and the italic style, which is
// already sans-serif). Previously they used the SERIF blocks (U+1D400 / U+1D468), which made
// bold words render in a clashing serif typeface on LinkedIn (SUP-519).
//
// The `legacy*` blocks below are the old serif code points, kept ONLY so we can still detect
// and normalize content that was bolded before this fix (saved drafts, re-imported posts).
export const unicodes = {
  bold: {
    A: 0x1d5d4, // 𝗔 MATHEMATICAL SANS-SERIF BOLD CAPITAL A
    a: 0x1d5ee, // 𝗮 MATHEMATICAL SANS-SERIF BOLD SMALL A
    z: 0x1d607, // 𝘇 MATHEMATICAL SANS-SERIF BOLD SMALL Z
    Z: 0x1d5ed // 𝗭 MATHEMATICAL SANS-SERIF BOLD CAPITAL Z
  },
  italic: {
    A: '𝘈'.codePointAt(0),
    a: '𝘢'.codePointAt(0),
    z: '𝘻'.codePointAt(0),
    Z: '𝘡'.codePointAt(0)
  },
  normal: {
    A: 'A'.codePointAt(0),
    a: 'a'.codePointAt(0),
    z: 'z'.codePointAt(0),
    Z: 'Z'.codePointAt(0)
  },
  boldItalic: {
    A: 0x1d63c, // 𝘼 MATHEMATICAL SANS-SERIF BOLD ITALIC CAPITAL A
    a: 0x1d656, // 𝙖 MATHEMATICAL SANS-SERIF BOLD ITALIC SMALL A
    z: 0x1d66f, // 𝙯 MATHEMATICAL SANS-SERIF BOLD ITALIC SMALL Z
    Z: 0x1d655 // 𝙕 MATHEMATICAL SANS-SERIF BOLD ITALIC CAPITAL Z
  },
  // Legacy serif blocks — retained for backward-compatible detection/normalization only.
  legacyBold: {
    A: 0x1d400, // 𝐀 MATHEMATICAL BOLD CAPITAL A
    a: 0x1d41a, // 𝐚 MATHEMATICAL BOLD SMALL A
    z: 0x1d433, // 𝐳 MATHEMATICAL BOLD SMALL Z
    Z: 0x1d419 // 𝐙 MATHEMATICAL BOLD CAPITAL Z
  },
  legacyBoldItalic: {
    A: 0x1d468, // 𝑨 MATHEMATICAL BOLD ITALIC CAPITAL A
    a: 0x1d482, // 𝒂 MATHEMATICAL BOLD ITALIC SMALL A
    z: 0x1d49b, // 𝒛 MATHEMATICAL BOLD ITALIC SMALL Z
    Z: 0x1d481 // 𝒁 MATHEMATICAL BOLD ITALIC CAPITAL Z
  }
}


// function convertStringToBold(str) {
//   // convert the string to bold
//   let boldStr = "";
//   for (let i = 0; i < str.length; i++) {
//     const charCode = str.codePointAt(i);
//     // check if the charCode is between normal A and Z
//     if (charCode >= unicodes.normal.A && charCode <= unicodes.normal.Z) {
//       boldStr += String.fromCodePoint(charCode + unicodes.bold.A - unicodes.normal.A);
//     }
//     // check if the charCode is between normal a and z
//     else if (charCode >= unicodes.normal.a && charCode <= unicodes.normal.z) {
//       boldStr += String.fromCodePoint(charCode + unicodes.bold.a - unicodes.normal.a);
//     }
//     // if not, just add the character as it is
//     else {
//       boldStr += str[i];
//     }

//   }
//   return boldStr;
// }

// function convertStringToItalic(str) {
//   let italicStr = "";
//   for (let i = 0; i < str.length; i++) {
//     const charCode = str.codePointAt(i);
//     // check if the charCode is between normal A and Z
//     if (charCode >= unicodes.normal.A && charCode <= unicodes.normal.Z) {
//       italicStr += String.fromCodePoint(charCode + unicodes.italic.A - unicodes.normal.A);
//     }
//     // check if the charCode is between normal a and z
//     else if (charCode >= unicodes.normal.a && charCode <= unicodes.normal.z) {
//       italicStr += String.fromCodePoint(charCode + unicodes.italic.a - unicodes.normal.a);
//     }
//     // if not, just add the character as it is
//     else {
//       italicStr += str[i];
//     }

//   }
//   return italicStr;
// }

// function convertStringToBoldItalic(str) {
//   let boldItalicStr = "";
//   for (let i = 0; i < str.length; i++) {
//     const charCode = str.codePointAt(i);
//     // check if the charCode is between normal A and Z
//     if (charCode >= unicodes.normal.A && charCode <= unicodes.normal.Z) {
//       boldItalicStr += String.fromCodePoint(charCode + unicodes.boldItalic.A - unicodes.normal.A);
//     }
//     // check if the charCode is between normal a and z
//     else if (charCode >= unicodes.normal.a && charCode <= unicodes.normal.z) {
//       boldItalicStr += String.fromCodePoint(charCode + unicodes.boldItalic.a - unicodes.normal.a);
//     }
//     // if not, just add the character as it is
//     else {
//       boldItalicStr += str[i];
//     }

//   }
//   return boldItalicStr;
// }

// function convertStringToNormal(str) {
//   let normalStr = "";
//   for (let i = 0; i < str.length; i++) {
//     const charCode = str.codePointAt(i);
//     // check if the charCode is between normal A and Z
//     if (charCode >= unicodes.bold.A && charCode <= unicodes.bold.Z) {
//       normalStr += String.fromCodePoint(charCode + unicodes.normal.A - unicodes.bold.A);
//     }
//     // check if the charCode is between normal a and z
//     else if (charCode >= unicodes.bold.a && charCode <= unicodes.bold.z) {
//       normalStr += String.fromCodePoint(charCode + unicodes.normal.a - unicodes.bold.a);
//     }
//     // if not, just add the character as it is
//     else {
//       normalStr += str[i];
//     }

//   }
//   return normalStr;
// }

// function convertStringToNormalItalic(str) {
//   let normalItalicStr = "";
//   for (let i = 0; i < str.length; i++) {
//     const charCode = str.codePointAt(i);
//     // check if the charCode is between normal A and Z
//     if (charCode >= unicodes.boldItalic.A && charCode <= unicodes.boldItalic.Z) {
//       normalItalicStr += String.fromCodePoint(charCode + unicodes.normal.A - unicodes.boldItalic.A);
//     }
//     // check if the charCode is between normal a and z
//     else if (charCode >= unicodes.boldItalic.a && charCode <= unicodes.boldItalic.z) {
//       normalItalicStr += String.fromCodePoint(charCode + unicodes.normal.a - unicodes.boldItalic.a);
//     }
//     // if not, just add the character as it is
//     else {
//       normalItalicStr += str[i];
//     }

//   }
//   return normalItalicStr;
// }


// export {
//   convertStringToBold,
//   convertStringToItalic,
//   convertStringToBoldItalic,
//   convertStringToNormal,
//   convertStringToNormalItalic
// }
